module.exports = __webpack_public_path__ + "img/exit_5.2a472dac.svg";